import React, { useState } from "react";
import {
    useSelector,
    useDispatch,
} from "react-redux";
import ErrorOverlay from "../../UserComponents/overlays/ErrorOverlay.js";
import PenaltySettingsModal from "../settingPenaltyDescription/components/PenaltySettingsModal";
import Entypo from "@mui/icons-material/ArrowBack"; // Using Material UI for icons
import DensitySmallIcon from '@mui/icons-material/DensitySmall';
import DescriptionIcon from '@mui/icons-material/Description';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ExposureIcon from '@mui/icons-material/Exposure';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import "./AccSettings.css"
import UserSidebar from "../../../components/userSiderbar/userSidebar.jsx";


const AccountSettings = (props) => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth.user);
    const operatorTeam = useSelector((state) => state.team.selectedTeam);

    const [error, setError] = useState(null);
    const [penaltyModalVisible, setPenaltyModalVisible] = useState(false);
    const [selectedRule, setSelectedRule] = useState(null);

    return (
        <div className="settings-container">
            <UserSidebar />
            <ErrorOverlay
                onBackdropPress={() => setError(null)}
                visible={!!error}
                error={error}
            />
            <div className="settings-header">
                {/* <h1 className="header-txt-settings">ACCOUNT SETTINGS</h1> */}
            </div>

            <div className="account-settings-btn-container">
                <div
                    className="account-details"
                >
                    <div className="text-container-settings" style={{width: "100%"}}>
                        <h1 className="btn-txt-settings" style={{ color: 'white', fontSize: "2rem", borderBottom: "2px solid white" }}>ACCOUNT DETAILS</h1>
                    </div>
                        <p className="details-txt">Name: {user?.userName || 'none'}</p>
                        <p className="details-txt"> Organization Name: {user?.organizationName || 'none'}</p>
                        <p className="details-txt">Email: {user?.email || 'none'}</p>
                        <p className="details-txt"> Contact Number: {user?.contactNumber || 'none'}</p>
                </div>
                <button
                    onClick={() => props.history.push("/accountsharing")}
                    className="account-settings-btn"
                >
                    <div className="text-container-settings">
                        <p className="btn-txt-settings">ACCOUNT SHARING</p>
                    </div>
                    <div className="icon-circle-settings">
                        <ArrowForwardIcon fontSize="small" className="icon-settings" />
                    </div>
                </button>

                {/* <button
                    // onClick={() => props.history.push("/setting-turnover-description")}
                    className="account-settings-btn"
                >
                    <p className="btn-txt-settings">CHANGE PASSWORD</p>
                    <div className="icon-circle-settings">
                        <ArrowForwardIcon fontSize="small" className="icon-settings" />
                    </div>
                </button> */}

                <button
                    onClick={() => props.history.push("/editaccountinfo")}
                    className="account-settings-btn"
                >
                    <p className="btn-txt-settings">EDIT USER INFORMATION</p>
                    <div className="icon-circle-settings">
                        <ArrowForwardIcon fontSize="small" className="icon-settings" />
                    </div>
                </button>

                <button
                    className="account-settings-btn">
                    <p className="btn-txt-settings" style={{ color: '#a30606', padding: '11px' }}>DELETE ACCOUNT</p>
                </button>
            </div>

            <PenaltySettingsModal
                onBackdropPress={() => setPenaltyModalVisible(false)}
                visible={penaltyModalVisible}
                navigation={props.history}
            />
        </div>
    );
};

export default AccountSettings;
